if (!customElements.get("m-unik-green-revolution")) {
  class MUnikGreenRevolution extends HTMLElement {
    constructor() {
      super();

      this.enableSlider = this.dataset.enableSlider === "true";
      this.items = parseInt(this.dataset.items) || 4;
      this.showPagination = this.dataset.showPagination === "true";
      this.showNavigation = this.dataset.showNavigation === "true";
      this.autoplay = this.dataset.autoplay === "true";
      this.autoplaySpeed = parseInt(this.dataset.autoplaySpeed) || 5000;
      this.slideContainer = this.querySelector(".swiper-container");
      this.isTouch = "ontouchstart" in window || navigator.maxTouchPoints > 0;
    }

    connectedCallback() {
      this.lastActive = null;
      if (this.enableSlider && this.slideContainer) this.initSlider();
      this.initFlipCards();
    }

    initSlider() {
      const controlsContainer = this.querySelector(".m-slider-controls");
      const prevButton = controlsContainer && controlsContainer.querySelector(".m-slider-controls__button-prev");
      const nextButton = controlsContainer && controlsContainer.querySelector(".m-slider-controls__button-next");
      const slideItemsLength = this.querySelector(".swiper-wrapper").childElementCount;
      let __this = this;

      const gap = parseInt(getComputedStyle(this).getPropertyValue('--column-gap')) || 30;
      const gapMobile = parseInt(getComputedStyle(this).getPropertyValue('--column-gap-mobile')) || 10;

      this.slider = new MinimogLibs.Swiper(this.slideContainer, {
        slidesPerView: 1,
        spaceBetween: gapMobile,
        navigation: this.showNavigation,
        loop: false,
        autoplay: this.autoplay ? {
          delay: this.autoplaySpeed,
          disableOnInteraction: false,
        } : false,
        pagination: this.showPagination
          ? {
              el: this.querySelector(".swiper-pagination"),
              clickable: true,
            }
          : false,
        breakpoints: {
          480: {
            slidesPerView: 2,
            spaceBetween: gapMobile,
          },
          768: {
            slidesPerView: Math.max(1, parseInt(this.items) - 1),
            spaceBetween: gap,
          },
          1280: {
            slidesPerView: parseInt(this.items),
            spaceBetween: gap,
          },
        },
        on: {
          init: function () {
            if (__this.lastActive !== null) this.slideTo(__this.lastActive);
            setTimeout(() => {
              // Positionnement des boutons de navigation au centre de l'image/picto
              const firstItem = __this.querySelector(".unik-green-revolution__picto-wrapper") || __this.querySelector(".unik-green-revolution__flip-card");
              if (firstItem && controlsContainer) {
                const itemHeight = firstItem.clientHeight;
                controlsContainer.style.setProperty("--offset-top", parseInt(itemHeight) / 2 + "px");

                if (prevButton) prevButton.classList.remove("m:hidden");
                if (nextButton) nextButton.classList.remove("m:hidden");
              }
            }, 200);
          },
          breakpoint: (swiper, breakpointParams) => {
            if (controlsContainer) {
              const { slidesPerView } = breakpointParams;
              if (slideItemsLength > slidesPerView) {
                controlsContainer.classList.remove("m:hidden");
                swiper.allowTouchMove = true;
              } else {
                controlsContainer.classList.add("m:hidden");
                swiper.allowTouchMove = false;
              }
            }
          },
        },
      });

      if (this.slider && this.showNavigation) {
        prevButton && prevButton.addEventListener("click", () => this.slider.slidePrev());
        nextButton && nextButton.addEventListener("click", () => this.slider.slideNext());
      }
      this.addEventListener("shopify:block:select", (e) => this.onBlockSelect(e));
    }

    initFlipCards() {
      // Délégation d'événements pour gérer tactilement le retournement des cartes
      this.addEventListener("click", (e) => {
        const card = e.target.closest(".unik-green-revolution__flip-card");
        if (!card) return;

        // Seulement sur tactile
        if (this.isTouch) {
          e.preventDefault();
          const flipCards = this.querySelectorAll(".unik-green-revolution__flip-card");
          flipCards.forEach((other) => {
            if (other !== card) {
              other.classList.remove("is-flipped");
            }
          });
          card.classList.toggle("is-flipped");
        }
      });
    }

    onBlockSelect(e) {
      const block = e.target;
      const index = Number(block.dataset.slide);
      this.lastActive = index;
      if (this.slider) {
        this.slider.slideTo(index);
      }

      // Simulation du flip sur l'éditeur pour prévisualisation
      const flipCard = block.querySelector(".unik-green-revolution__flip-card");
      if (flipCard) {
        flipCard.classList.add("is-flipped");
        setTimeout(() => flipCard.classList.remove("is-flipped"), 2000);
      }
    }
  }

  customElements.define("m-unik-green-revolution", MUnikGreenRevolution);
}
